import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { LogoutService } from './logout.service';

@Injectable({ providedIn: 'root' })
export class SignOutResolver implements Resolve<void> {
    constructor(private logoutService: LogoutService) {}

    async resolve(): Promise<void> {
        await this.logoutService.logoutAndRedirect();
    }
}
